import { Component } from '@angular/core';
import {BasePageComponent} from "../../../../../../base/component/BasePageComponent";
import {BaseEntity, BaseState} from "../../../../../../base/entities/BaseEntities";
import {ServiceBagService, ServiceBagServices} from "@base/component/ServiceBag";
import {ContextMenuElement, ToolbarSettings} from "@base/classes/BaseClasses";
import { Location } from '@angular/common';

class State extends BaseState {}

@Component({
    providers: ServiceBagServices,
    selector: 'app-demo-page-toolbar-buttons',
    templateUrl: './demo-page-toolbar-buttons.component.html',
    styleUrls: ['../../../../styles/demo-styles.scss']
})
export class DemoPageToolbarButtonsComponent extends BasePageComponent<BaseEntity, State> {

    constructor(
        A: ServiceBagService,
        private location: Location) {
        
        super(A, 'DemoPageToolbarButtons', BaseEntity, State);
    }

    protected override OnInitTitle() : string {
        return 'Toolbar buttons';
    }
    
    protected override OnGetToolbarSettings() {
        const settings = new ToolbarSettings();

        settings.IsAllowFilter = true;
        settings.IsAllowExport = true;
        settings.IsAllowPrint = true;

        settings.ShowBackButton = true;
        settings.BackButtonClick = () => this.location.back();

        settings.ContextMenuTitle = "Context menu";
        settings.OnGetContextMenuItems = this.GetContextMenu;

        return settings;
    }

    private GetContextMenu(): ContextMenuElement[] {
        return [
            {
                text: 'Add',
                icon: 'add',
                onClick: () => console.log('Context Menu - add button clicked.')
            },
            {
                text: 'Edit',
                icon: 'edit',
                onClick: () => console.log('Context Menu - edit button clicked.')
            }
        ]
    }
}
